export default __webpack_public_path__ + "static/media/AccordionArrowUp.7185f771.svg";